<template>
  <div class="dashboard-container">
    <side-bar />
    <div class="main-content">
      <div class="container">
        <component src="https://c2hbe361.caspio.com/dp/76bfd00068f7e5a166af48629286/emb" :is="'script'"></component>
      </div>
      <h3>AI Agent Creation Options</h3>
      <p>Choose one of the options below to get started</p>
      <div class="card-container">
        <div class="card">
          <div class="card-content">
            <p>Create a pre-configured demo AI Agent to showcase AI Agent capabilities</p>
          </div>
          <router-link to="/partner/demo/main" class="btn-link">
            <button class="card-button">Setup demo AI Agent</button>
          </router-link>
        </div>
        <div class="card">
          <div class="card-content">
            <p>Provision a new custom AI Agent in a few simple steps using the AI Agent wizard</p>
          </div>
          <router-link to="/partner/bot-wizard/main" class="btn-link">
            <button class="card-button">Custom AI Agent Wizard</button>
          </router-link>
        </div>
        <div class="card">
          <div class="card-content">
            <p>Create a discovery sheet for capturing the requirements of a new AI Agent</p>
          </div>
          <router-link to="/bot-discovery" class="btn-link">
            <button class="card-button">AI Agent discovery</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from './SideBar.vue'

export default {
  name: 'NewBot',
  components: {
    SideBar,
  },
}
</script>

<style scoped>
.sidebar {
  max-width: 10vw;
}

.flex-container {
  display: flex;
  flex-direction: row;
}

h3 {
  margin-left: 20px;
  font-size: 24px;
  font-weight: normal;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  justify-content: center;
  gap: 10px;
  margin: 20px;
}

.card {
  width: 300px;
  margin: 20px;
  border: 1px solid #e45f2b;
  border-radius: 5px;
  padding: 20px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);

}

p {
  text-align: left;
  margin-left: 20px;
}

.card-content {
  margin-bottom: 10px;
}

.card-button {
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  display: block;
  margin: 0 auto;
}

.btn-link {
  text-decoration: none;
}
</style>